function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import { useCalendar, useLocale } from "react-aria";
import { useCalendarState } from "react-stately";
import { createCalendar, getLocalTimeZone, today } from "@internationalized/date";
import { Box } from "sprout-ui-primitives";
import CalendarMonth from "./CalendarMonth";
import useCustomWeekDays from "./useCustomWeekDays";
const Calendar = (props)=>{
    const { variant  } = props, rest = _objectWithoutProperties(props, [
        "variant"
    ]);
    const { locale  } = useLocale();
    const scheduler = variant === "scheduler";
    const restProps = useMemo(()=>{
        const todayDate = today(getLocalTimeZone());
        return _objectSpread({}, rest, {
            minValue: scheduler ? todayDate.add({
                days: 1
            }) : undefined,
            defaultFocusedValue: scheduler ? todayDate : undefined
        });
    }, [
        rest,
        scheduler
    ]);
    const state = useCalendarState(_objectSpread({}, restProps, {
        locale,
        createCalendar,
        visibleDuration: scheduler ? {
            months: 2
        } : undefined
    }));
    const { calendarProps  } = useCalendar(restProps, state);
    const weekDays = useCustomWeekDays();
    return /*#__PURE__*/ _jsx(Box, _objectSpread({}, calendarProps, {
        children: /*#__PURE__*/ _jsx(CalendarMonth, {
            state: state,
            startDate: state.visibleRange.start,
            variant: variant,
            thead: /*#__PURE__*/ _jsx("thead", {
                children: /*#__PURE__*/ _jsx("tr", {
                    children: weekDays.map((day, index)=>/*#__PURE__*/ _jsx(Box, {
                            as: "th",
                            height: "36px",
                            color: "white.100",
                            fontWeight: "bold",
                            children: day
                        }, index))
                })
            })
        })
    }));
};
export default Calendar;
